export default function (name, handler){
    if (!this.messageHandlers[name]) {
      return false;
    }

    var index = this.messageHandlers[name].indexOf(handler);
    if (this.has(name, handler)) {
      this.messageHandlers[name].splice(index, 1);
    }

    return handler;
}